<template>
   <div style="background-color: white">


      <!--<Section background="white"  class="image-bg"-->
      <!--         :style="{'background-image': `url(${require('../../assets/images/content/pexels-pixabay-33153.jpg')})`}"-->

      <!--&gt;-->

      <!--   <nav-bar dark></nav-bar>-->

      <!--   <div class=" main-heading" style=" width: 100%;" >-->
      <!--      <v-container fluid class="heading-line">-->

      <!--         <div class="center display-2">-->
      <!--            &lt;!&ndash;Bible Study&ndash;&gt;-->
      <!--            聖書研究-->
      <!--         </div>-->
      <!--         &lt;!&ndash;<div class="center display-1">Radio Archive</div>&ndash;&gt;-->


      <!--      </v-container>-->
      <!--   </div>-->


      <!--</Section>-->


      <div style="height: 30px">

      </div>



      <div class="main-content-container">
         <p><a href="../data/bible_study/Bible_Study_Guide_01.pdf">1 この世にまだ信頼できるものが残されているのか</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_02.pdf">2 神が悪魔を創られたのか</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_03.pdf">3 天からの救助</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_04.pdf">4 宇宙に浮かぶ都</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_05.pdf">5 幸せな結婚への鍵</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_06.pdf">6 石に刻まれた不変のもの</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_07.pdf">7 歴史における失われた日</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_08.pdf">8 最終的な救出</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_09.pdf">9 純潔と力！</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_10.pdf">10 死人は本当に死んでいるのだろうか</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_11.pdf">11 悪魔は地獄の管理人なのか？</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_12.pdf">12 千年の平和</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_13.pdf">13 神が立てられた無料の健康増進計画</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_14.pdf">14 服従は律法主義か</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_15.pdf">15 反キリストとはだれなのか</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_16.pdf">16 宇宙からの天使のメッセージ</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_17.pdf">17 神の救いの計画 </a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_18.pdf">18 時間通り！　預言の時が解明された！</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_19.pdf">19 裁判の終了</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_20.pdf">20 獣の刻印</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_21.pdf">21 聖書の預言に現れたアメリカ合衆国</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_22.pdf">22 もう一人の女</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_23.pdf">23 キリストの花嫁</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_24.pdf">24 神は占星術師や霊能者に霊感を与えられるのか</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_25.pdf">25 われわれは、神を信頼するか</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_26.pdf">26 人を変える愛</a></p>
         <p><a href="../data/bible_study/Bible_Study_Guide_27.pdf">27 もはや後戻りできない。</a></p>
      </div>




   </div>
</template>

<script>
import navBar from "@/components/navBar";
import Section from "@/components/Section";


export default {
   name: "bibleStudy",
   components: {navBar, Section, },
}
</script>

<style scoped>
.image-bg{
    background-size: cover;
    background-position: center;
    height: 300px;
}

td{
    padding-left: 10px;
    padding-right: 10px;
}


.main-heading{
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;

}


.heading-line{
    text-align: center;
    color:#ffffff;
    /*background-color:rgba(43,43,43,0.4);*/
    width: 100%;

}


a:link {
    color: #0074ff;
}

/* visited link */
a:visited {
    color: #0074ff;
}

/* mouse over link */
a:hover {
    color: #010aef;
}


</style>